import { render } from "./padel-confirm-signup.template.html?vue&type=template&id=a6ddb6e8&scoped=true"
import script from "./PadelConfirmSignup.vue?vue&type=script&lang=ts"
export * from "./PadelConfirmSignup.vue?vue&type=script&lang=ts"

import "./PadelConfirmSignup.vue?vue&type=style&index=0&id=a6ddb6e8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a6ddb6e8"

export default script